/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorDto
 */
export interface ErrorDto {
    /**
     * 
     * @type {Date}
     * @memberof ErrorDto
     */
    dateTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ErrorDto
     */
    errorCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ErrorDto
     */
    hoursOfCrusherOperation?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ErrorDto
     */
    hoursOfEngineOperation?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ErrorDto
     */
    engineErrorSPN?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ErrorDto
     */
    engineErrorFMI?: number | null;
}

export function ErrorDtoFromJSON(json: any): ErrorDto {
    return ErrorDtoFromJSONTyped(json, false);
}

export function ErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    console.log("In ErrorDto.ErrorDtoFromJSONTyped");
    return {
        
        'dateTime': !exists(json, 'dateTime') ? undefined : (new Date(json['dateTime'])),
        'errorCode': !exists(json, 'errorCode') ? undefined : json['errorCode'],
        'hoursOfCrusherOperation': !exists(json, 'hoursOfCrusherOperation') ? undefined : json['hoursOfCrusherOperation'],
        'hoursOfEngineOperation': !exists(json, 'hoursOfEngineOperation') ? undefined : json['hoursOfEngineOperation'],
        'engineErrorSPN': !exists(json, 'engineErrorSPN') ? undefined : json['engineErrorSPN'],
        'engineErrorFMI': !exists(json, 'engineErrorFMI') ? undefined : json['engineErrorFMI'],
    };
}

export function ErrorDtoToJSON(value?: ErrorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    console.log("In ErrorDto.ErrorDtoToJSON");
    return {
        
        'dateTime': value.dateTime === undefined ? undefined : (value.dateTime.toISOString()),
        'errorCode': value.errorCode,
        'hoursOfCrusherOperation': value.hoursOfCrusherOperation,
        'hoursOfEngineOperation': value.hoursOfEngineOperation,
        'engineErrorSPN': value.engineErrorSPN,
        'engineErrorFMI': value.engineErrorFMI,
    };
}


